<template>
	<app>
		<div class="banner"></div>
		
		<module class="list">
			<h1>操作帮助中心</h1>
			
			<ul class="flex-wrap">
				<li v-for="(item, i) in videoList" :key="i" @click="$preview({src: item.video})">
					<video :src="item.video"></video>
					<p>{{item.name}}</p>
				</li>
			</ul>
		</module>
	</app>
</template>

<script>
	export default {
		data() {
			return {
				videoList: [{
					name: '企业保函申报购买操作流程',
					video: 'https://api.szbhjg.cn/upload/企业保函申报购买操作流程.mp4'
				}, {
					name: '保险单审批操作教程',
					video: 'https://api.szbhjg.cn/upload/保险单审批操作教程.mp4'
				}]
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.banner {
		height: 348px;
		background-image: url('~@/assets/image/banner.jpg');
		background-position: center;
		background-size: cover;
	}
	
	.list {
		min-height: 500px;
		
		h1 {
			line-height: 96px;
			font-size: 28px;
			font-weight: bold;
			color: #000;
			
			elder({
				line-height: 136px,
				font-size: 44px
			})
		}
		
		li {
			position: relative;
			width: 370px;
			margin-bottom: 30px;
			margin-left: 44px;
			cursor: pointer;
			
			&:nth-child(3n+1) {
				margin-left: 0;
			}
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
			}
			
			video {
				width: 370px;
				height: 208px;
				background: #000;
			}
			
			p {
				line-height: 52px;
				font-size: 18px;
				color: #333;
				
				elder({
					line-height: 62px,
					font-size: 28px
				})
			}
		}
	}
</style>
